/**
 * `comps.promotion` (CF-15; config-plan §1d, decision 26): the deal-to-comp auto-promote switch (R28),
 * an env variable until CF-15. Read by API services/deal-promotion/promote-deal-to-comp.ts.
 *
 *   auto_promote_deals   a deal that closes becomes a comp. The pipeline is inert until the Deals
 *                        lifecycle ships: on or off, POST /api/workflows/promote-deal-to-comp answers
 *                        503 not_activated today (only its reason changes).
 *
 * Zero change on the day: no row exists, so the value is DEAL_TO_COMP_AUTOPROMOTE_ENABLED exactly as the
 * code read it (on only for the text "true"), else off.
 *
 * Who: editPermission feature:system_settings (production: Admin and Super Admin); every save needs a
 * reason. Edited on Settings → App settings.
 */
import { z } from 'zod';
import { defineGroup } from '../define.js';
export const compsPromotion = defineGroup('comps.promotion', {
    label: 'Deal to comp promotion',
    editPermission: 'feature:system_settings',
    requireReason: true,
    settings: {
        auto_promote_deals: {
            type: z.boolean(),
            default: false,
            label: 'Turn closed deals into comps automatically',
            help: 'Waits for the Deals lifecycle: until it ships, no comp is created either way.',
            env: 'DEAL_TO_COMP_AUTOPROMOTE_ENABLED',
            envParse: (raw) => raw === 'true',
        },
    },
});
//# sourceMappingURL=comps.js.map